import { Repository } from 'aurelia-orm';
import { Tenant } from 'data/entities/entities';

export class TenantRepository extends Repository {

	rejectChanges(item: any): any {
		item.reset();// setData(item).__cleanValues.data.entity;
	}
	//Automatically filtered on the Server
	async findByAppUserId() {
		return await this.find();
	}

	checkForDuplicateTeam(teamName: string) {
		return this.find(`validateDuplicateTeam?tenantName=${teamName}`, true);
	}
}